import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

// import AccessTimeIcon from '@material-ui/icons/AccessTime';
import IslandIcon from 'Icons/IslandIcon';
import Tooltip from '@material-ui/core/Tooltip';

import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { shortDateAtTime } from 'Consts/DateFormats';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.facet.red,
    height: theme.spacing(3),
    width: theme.spacing(3),
    borderRadius: '50%',
    position: 'absolute',
    bottom: 0,
    right: theme.spacing(-1),
    top: theme.spacing(3.5),
    border: `2px solid ${theme.palette.common.white}`,
  },
  icon: {
    fontSize: '1rem',
  },
  outOfOfficeTitle: {
    color: theme.palette.facet.primaryBlue,
  },
});

const OutOfOfficeTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.facet.primaryBlue,
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.facet.lightGray}`,
    boxShadow: theme.shadows[3],
  },
}))(Tooltip);

const MessageAvatarOutOfOfficeIndicator = ({
  className,
  classes,
  messageResource,
}) => {
  const { rootNodeProps } = useEventTrackingLogEvent({ nodeName: 'Avatar Out of Office Tooltip' });

  // Is Out of office
  const isOutOfOffice = messageResource?.attr('senderOutOfOffice') === 'true';

  if (!isOutOfOffice) return null;

  return (
    <OutOfOfficeTooltip
      placement={'top-start'}
      enterDelay={800}
      title={
        <React.Fragment>
          <Typography
            className={classes.outOfOfficeTitle}
            color="inherit"
            variant={'h6'}
            weight={'bold'}
          >
            {`${messageResource?.attr('from')} is currently out of office`}
          </Typography>
          { messageResource.attr('senderOutOfOfficeReturnTime')
            ? (
              <Typography
                color={'primaryGray'}
                variant={'body1'}
                weight={'book'}
              >
                {`Return Date: ${moment(messageResource?.attr('senderOutOfOfficeReturnTime')).format(shortDateAtTime)}`}
              </Typography>) : null}
        </React.Fragment>
      }
    >
      <div
        className={classNames(classes.root, className)}
        test={'avatar-out-of-office-indicator'}
        {...rootNodeProps}
      >
        <IslandIcon
          className={classes.icon}
        />
      </div>
    </OutOfOfficeTooltip>
  );
};

MessageAvatarOutOfOfficeIndicator.defaultProps = {
  className: '',
};

MessageAvatarOutOfOfficeIndicator.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  messageResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(MessageAvatarOutOfOfficeIndicator);
